import { Dialog } from "vant";
import wx from "weixin-js-sdk";
import router from "@/router";
// 判断是否是http ,https链接
export const isValidHttpOrHttpsUrl = urlString => {
  // 正则表达式用于匹配以http或https开头的URL
  var regex = /^(https?:\/\/).*$/; // 注意这里'?'使得's'变为可选字符
  // 使用test方法检查字符串是否符合正则规则
  return regex.test(urlString);
};

function doesNotContainDisallowedStrings(url) {
  const disallowedStrings = [
    "bytx.care-gobroad.com",
    "https://bytx.care-gobroad.com",
    "care-yyh.com",
    "https://care-yyh.com",
    "https://byh-api.dr-gobroad.com",
    "byh-api.dr-gobroad.com",
    "https://mp.weixin.qq.com/mp/appmsgalbum"
  ];

  return disallowedStrings.every(string => url.indexOf(string) === -1);
}
const isWXmini = () => {
  let flag = false;
  wx.miniProgram.getEnv(function(res) {
    flag = res.miniprogram;
  });
  return flag;
};

export const LocationHref = url => {
  const isMini = localStorage.getItem("isMini");
  // if (isMini === "1") {
  if (isMini === "1" && isWXmini()) {
    if (isValidHttpOrHttpsUrl(url)) {
      if (doesNotContainDisallowedStrings(url)) {
        Dialog.alert({
          title: "添加助手",
          message: `<div style="white-space:normal;">
                                  <div class="dialog-span-1">长按识别添加助手，获取页面链接</div>
                                  <img class="w-190px h-190px" src="/static/bytx/anticancer/QR-code.svg">
                              </div>`,
          allowHtml: true,
          confirmButtonColor: "#000"
        }).then(() => {
          // on close
        });
      } else {
        window.location.href = url;
      }
    } else {
      window.location.href = url;
    }
  } else {
    window.location.href = url;
  }
};

export const toHomePage = () => {
  if (localStorage.getItem("isMini") == 1 && isWXmini()) {
    wx.closeWindow(); // 关闭网页
    wx.miniProgram.reLaunch({ url: "/pages/home/index" });
  } else {
    router.push({ name: "home" });
  }
};

/**
 * 导航至微信小程序的指定页面。
 * @param {Object} query 跳转参数对象，包含以下属性：
 *   - {string} appId 目标小程序的AppID。
 *   - {string} path 要打开的小程序页面的路径。
 *   - {string} [shortLink] 可选的短链接，用于快速跳转。
 *   - {Object} [extraData] 可选的额外数据，将传递给目标小程序。
 * @param {Function} fn 如果当前不在小程序环境中或不是微信小程序，则执行的回调函数。
 */
export const navigateToMiniProgram = (query, fn) => {
  const { appId, path, shortLink, extraData } = query;

  // 检查是否已经在小程序环境中，并且是微信小程序
  if (localStorage.getItem("isMini") == 1 && isWXmini()) {
    // 向当前小程序页面发送消息，触发跳转
    const params = {};

    // 仅当相应参数存在时，将其添加到跳转参数对象中
    if (appId) {
      params.appId = appId;
    }
    if (path) {
      params.path = path;
    }
    if (shortLink) {
      params.shortLink = shortLink;
    }
    if (shortLink) {
      params.extraData = extraData;
    }

    wx.miniProgram.postMessage({
      data: {
        type: "navigateToMiniProgram", // 消息类型，用于业务逻辑处理
        params: params
      }
    });
  } else {
    fn(); // 当前环境不满足跳转条件时，执行传入的回调函数
  }
};

// 跳转到小程序指定页面
export const toMiniProgramPage = (url, scene,miniUrl) => {
  if (localStorage.getItem("isMini") == 1 && isWXmini()) {
    wx.closeWindow(); // 关闭网页
    if (scene === "redirectTo") {
      wx.miniProgram.redirectTo({ url: miniUrl });
    }else if (scene === "navigateTo") {
      wx.miniProgram.navigateTo({ url: miniUrl });
    }else if (scene === "switchTab") {
      wx.miniProgram.switchTab({ url: miniUrl });
    }else if (scene === "reLaunch") {
      wx.miniProgram.reLaunch({ url: miniUrl});
    }
  } else {
    url = url.replace("https://bytx.care-gobroad.com", "");
    url = url.replace("https://bytx.care-gobroad.com", "");
    LocationHref(url);
  }
};



// WEBPACK FOOTER //
// ./src/util/common.js